
// Some libraries expect jQuery to be a global variable. We need to make it available to those libraries
// /app/js/jquery-shims lists the libraries that need jQuery
define('jquery-private',['jquery'], function (jQuery) {
    require(['./app/js/jquery-shims'], function () { jQuery.noConflict(true); });
    return jQuery;
});
